import { createReducer, on } from '@ngrx/store';
import { PageAccessLogDTO } from 'brain-data/model/access-log.model';
import { AccessLogQuery } from 'brain-data/service/access-log/access-log-admin.service';
import { loadAdminAccessLogs, loadAdminAccessLogsError, loadAdminAccessLogsSuccess } from '../actions/access-log.action';

export default interface AccessLogState {
  isLoading: boolean;
  error?: any;
  page?: PageAccessLogDTO;
  lastQuery?: AccessLogQuery;
}

export const initialState: AccessLogState = {
  isLoading: false,
  error: undefined,
  page: undefined,
  lastQuery: undefined,
};

export const reducer = createReducer(
  initialState,
  on(
    loadAdminAccessLogs,
    (state, { query }): AccessLogState => ({
      ...state,
      isLoading: true,
      error: undefined,
      lastQuery: query,
    }),
  ),
  on(
    loadAdminAccessLogsSuccess,
    (state, { page }): AccessLogState => ({
      ...state,
      isLoading: false,
      page,
    }),
  ),
  on(
    loadAdminAccessLogsError,
    (state, { error }): AccessLogState => ({
      ...state,
      isLoading: false,
      error,
    }),
  ),
);
